import { api } from '@/services/backend/http-client';
import dayjs from 'dayjs';
import {
  CompanyProfileType,
  InvestorProfileType,
  ProfileRepresentativeRequestType,
  ProfileRepresentativeResponseType,
  UserProfileType,
} from './types';

export const getUserProfile = async (ignoreNotFound = false): Promise<UserProfileType> => {
  const response = await api.get('/profile', {
    responseInterceptorConfig: { ignoreStatusCodes: ignoreNotFound ? [404] : [] },
  });
  return response.data;
};

export const switchUserProfile = async (profileId: string): Promise<void> => {
  const response = await api.put('/profile/switch', {
    id: profileId,
  });
  return response.data;
};
export const getUserProfileDetails = async (): Promise<InvestorProfileType | CompanyProfileType> => {
  const response = await api.get('/profile/details');
  return response.data;
};

export const getUserProfileRepresentatives = async (): Promise<ProfileRepresentativeResponseType[]> => {
  const response = await api.get('/profile/representatives');
  return response.data;
};

export const getUserProfileRepresentative = async (id: string): Promise<ProfileRepresentativeResponseType> => {
  const response = await api.get(`/profile/representatives/${id}`);
  return response.data;
};

export const addCompanyRepresentative = async (
  request: ProfileRepresentativeRequestType,
): Promise<ProfileRepresentativeResponseType> => {
  const response = await api.post(`/profile/representatives`, request);
  return response.data;
};

export const editCompanyRepresentative = async (
  id: string,
  request: ProfileRepresentativeRequestType,
): Promise<ProfileRepresentativeResponseType> => {
  const response = await api.put(`/profile/representatives/${id}`, request);
  return response.data;
};

export const revokeRepresentativeAccess = async (id: string): Promise<void> => {
  const response = await api.put(`/profile/representatives/${id}/access-revoke`);
  return response.data;
};

export const grantRepresentativeAccess = async (id: string): Promise<void> => {
  const response = await api.put(`/profile/representatives/${id}/access-grant`);
  return response.data;
};

export const updateUserProfileDetails = async ({
  phoneNumber,
  emailAddress,
  languagePreference,
}: {
  phoneNumber: string;
  emailAddress: string;
  languagePreference: string;
}): Promise<void> => {
  const response = await api.put('/profile/details', {
    ...(phoneNumber && { phoneNumber }),
    ...(emailAddress && { emailAddress }),
    ...(languagePreference && { languagePreference }),
  });
  return response.data;
};

export const initializeProfileVerification = async ({
  civilNumber,
  idCardExpiryDate,
}: {
  civilNumber: string;
  idCardExpiryDate: Date;
}): Promise<void> => {
  const response = await api.put('/profile/verify/initialize', {
    civilNumber,
    idCardExpiryDate: dayjs(idCardExpiryDate).format('YYYY-MM-DD'),
  });
  return response.data;
};

export const confirmProfileVerification = async ({
  civilNumber,
  idCardExpiryDate,
  code,
}: {
  civilNumber: string;
  idCardExpiryDate: Date;
  code: string;
}): Promise<void> => {
  const response = await api.put('/profile/verify/confirm', {
    civilNumber,
    idCardExpiryDate: dayjs(idCardExpiryDate).format('YYYY-MM-DD'),
    code,
  });
  return response.data;
};
